import { useMutation } from "@tanstack/react-query";
import taskTypeService from "../api/taskTypeService";

export const useCreateTaskType = () => {
  const { createTaskType } = taskTypeService();

  return useMutation({
    mutationKey: ["create-task-type"],
    mutationFn: async ({ taskType }) => {
      const response = await createTaskType(taskType);
      return response.data;
    },
  });
};

export const useCreateTaxReturnTaskType = () => {
  const { createTaxReturnTaskType } = taskTypeService();

  return useMutation({
    mutationKey: ["create-tax-return-task-type"],
    mutationFn: async ({ boardId }) => {
      const response = await createTaxReturnTaskType(boardId);
      return response.data;
    },
  });
};

export const useUpdateTaskType = () => {
  const { updateTaskType } = taskTypeService();

  return useMutation({
    mutationKey: ["update-task-type"],
    mutationFn: async ({ taskType }) => {
      const response = await updateTaskType(taskType);
      return response.data;
    },
  });
};

export const useDeleteTaskType = () => {
  const { deleteTaskType } = taskTypeService();

  return useMutation({
    mutationKey: ["delete-task-type"],
    mutationFn: async ({ taskTypeId }) => {
      const response = await deleteTaskType(taskTypeId);
      return response.data;
    },
  });
};
